import icon from 'vue-svgicon';

icon.register({
    'regular/performance-increase-mail': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M22.5 11.25v10.5a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5v-10.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" d="M1.805 10.742l8.342 6.617a3 3 0 0 0 3.706 0l8.347-6.617M18.584 5.048l.916-3.383L16.118.75" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="2" d="M19.5 1.665l-5.055 2.9a.778.778 0 0 1-1.063-.287l-1.144-1.992A.778.778 0 0 0 11.176 2L6.6 4.626M17.25 14.664V8.25a.75.75 0 0 0-.75-.75h-2.25a.75.75 0 0 0-.75.75v9.35M10.5 17.6V9.75A.75.75 0 0 0 9.75 9H7.5a.75.75 0 0 0-.75.75v4.914M1.5 11.25L3.75 7.5M22.5 11.25L20.25 7.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
